<template>
    <l-popup>
          <div class="map-new">
              <TextareaAutosize
                class="map-new__title"
                type="text"
                v-model="event.title"
                placeholder="Опишите детали ивента..."
                maxlength="110"
                />
                <!-- <h3 class="new-subtitle">Выберите категории спорта</h3> -->
                <div class="map-new-sports">
                    <div class="map-button map-button_rainbow" @click="$store.dispatch('changeState', { element: 'sports_new', val: true });">
                        <p>Выбрать спорт</p>
                    </div>
                    <Sports :sports="getActiveSports" />
                </div>
                <div class="map-new-footer" :class="{normal: getActiveSports.length > 0}">

                <div class="map-new__publish" :class="{loading: 'load'}" @click="publish()">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="white"
                    viewBox="0 0 24 24"
                    v-if="!loading"
                    >
                    <path
                        d="M9.525 17.657l-4.95-4.95 1.414-1.414 3.537 3.534-.001.001 8.485-8.485 1.414 1.414-8.485 8.486-1.413 1.413-.001.001z"
                    />
                    </svg>
                    <svg v-else class="new-publish-loader" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                        <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                        <animateTransform 
                            attributeName="transform" 
                            attributeType="XML" 
                            type="rotate"
                            dur="1s" 
                            from="0 50 50"
                            to="360 50 50" 
                            repeatCount="indefinite" />
                    </path>
                    </svg>
                    </div>
                </div>
            </div>
        </l-popup>
</template>
<script>
import { LPopup } from "vue2-leaflet";
export default {
    name: 'popup-create',
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    data: () => {
        return {
            loading: false,
            options: {
                photos: true,
                private: true,
                chat: true,
                cover: true,
                users: false,
                max: 10,
            },
        }
    },
    components: {
        "l-popup": LPopup,
        Sports: () => import('@/components/Filters/SportsNew'),
    },
    computed: {
        getActiveSports() {
            return this.$store.getters.getActiveSportsNew;
        },
    },
    methods: {
        async publish() {
            let data = {
                title: this.event.title,
                start: this.start,
                end: this.end,
                author: this.event.author,
                position: {
                    longitude: this.event.position.lng, 
                    latitude: this.event.position.lat
                },
                sports: this.getActiveSports,
                options: this.options
            };

            if (!data.start && !data.end) {
                data.start = this.$moment();
                data.end = this.$moment().add(7, 'days');
            }
            

            if (!data.title) {
                this.$store.dispatch('addError', { message: 'Не введено название ивента' });
            } else if (!data.author) {
                this.$store.dispatch('addError', { message: 'Ошибка аутентификации' });
            } else if (this.$moment(data.start) >= this.$moment(data.end)) {
                this.$store.dispatch('addError', { message: 'Время начала не может быть позднее времени завершения! 😅' });
            } else if (this.$moment(data.end) < this.$moment()) {
                this.$store.dispatch('addError', { message: 'Время завершения не может быть в прошлом! 😅' });
            } else {
                this.loading = true;
                this.$axios.post('/api/zones/by_coords', {coords: data.position})
                .then( res => {
                    data.region = {
                        country: res.data.country,
                        state: res.data.state,
                        country_code: res.data.country_code, 
                        state_code: res.data.state_code
                    };
                    this.createEvent(data)
                })
                
            }
        },
        async createEvent(data) {
            let event = await this.$store.dispatch('createEvent', data);
            if (event && event.score) {
                this.$store.dispatch('addScore', event.score)
            }
            this.loading = false;
            this.$router.push({ name: 'event', params: { hash: event.id + '&' + event.hash } });
            this.$store.dispatch('addNotification', { message: 'Ваше мероприятие создано и будет активно 7 дней! 😎' });
            this.$emit('close')
        },
    }
}
</script>
<style lang="stylus">
.leaflet-container a.leaflet-popup-close-button
    top 8px
    right 8px
    transform scaleZ(1.2)
.map-new
    width 100%
    padding 20px

    &-sports
        display flex
        flex-direction column
        align-items flex-start
        margin-top 10px
        .sports
            margin-top 10px

    &__publish
        border 1px solid #53cbb5
        display flex
        align-items center
        justify-content center
        width 35px
        height 35px
        border-radius 50%
        svg
            width 27px !important
            fill #53cbb5
    
    &-footer
        display flex
        justify-content flex-end
        margin-top -40px
        &.normal
            margin-top 0
    

    &__title
        width 100%
        font-size 24px
        font-weight 500
        line-height 38px
        // padding 0 26px
        background-color transparent
        border none
        min-height 85px
        // padding-bottom 30px
        color #2E3A59
        // +placeholder()
        //     color #c7c7c7
        
        +to-width(400px)
            font-size 23px
</style>